var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 43.0547C33.6282 43.0547 43.0547 33.6282 43.0547 22C43.0547 10.3718 33.6282 0.945312 22 0.945312C10.3718 0.945312 0.945312 10.3718 0.945312 22C0.945312 33.6282 10.3718 43.0547 22 43.0547Z",
    fill: "#EEEDF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.252 29.1483C40.252 29.9881 40.0957 30.7889 39.8223 31.5409C39.666 31.9706 39.4707 32.3905 39.2266 32.7811C39.0215 33.1131 38.8359 33.4452 38.6504 33.7967L34.2266 42.3514C33.7676 43.2401 32.4883 43.2401 32.0293 42.3514L27.6055 33.7967C27.4297 33.4549 27.2344 33.1131 27.0293 32.7811C26.7949 32.3905 26.5996 31.9803 26.4336 31.5409C26.1602 30.7792 26.0039 29.9686 26.0039 29.1092C26.0039 25.1639 29.2168 21.9608 33.1816 21.9999C37.1074 22.0389 40.2715 25.2518 40.252 29.1483Z",
    fill: "#D3D5E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2559 22.1854C34.2461 23.4452 34.0215 24.6561 33.6211 25.7792C33.3867 26.4335 33.084 27.0487 32.7324 27.6346C32.4297 28.1327 32.1367 28.6405 31.873 29.1581L25.2227 42.0096C24.5293 43.3475 22.6152 43.3475 21.9219 42.0096L15.2715 29.1678C15.0078 28.6503 14.7148 28.1425 14.4121 27.6444C14.0605 27.0585 13.7578 26.4335 13.5234 25.7889C13.1133 24.6464 12.8887 23.4257 12.8887 22.1464C12.8887 16.2186 17.7227 11.4139 23.6699 11.4628C29.5293 11.4921 34.2852 16.3261 34.2559 22.1854Z",
    fill: "#D3D5E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1484 32.7911C19.1484 33.4064 19.0312 34.0021 18.8359 34.5489C18.7188 34.8712 18.5723 35.1739 18.3965 35.4572C18.25 35.7013 18.1035 35.9454 17.9766 36.1993L14.7148 42.4982C14.373 43.1525 13.4355 43.1525 13.0938 42.4982L9.83203 36.1993C9.70508 35.9454 9.55859 35.7013 9.41211 35.4572C9.23633 35.1739 9.08984 34.8614 8.97266 34.5489C8.76758 33.9923 8.66016 33.3868 8.66016 32.7618C8.66016 29.8517 11.0332 27.4982 13.9531 27.5177C16.8242 27.547 19.1582 29.92 19.1484 32.7911Z",
    fill: "#D3D5E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6836 22.1854C32.6738 23.4452 32.4492 24.6561 32.0488 25.7792C31.8145 26.4335 31.5117 27.0487 31.1602 27.6346C30.8574 28.1327 30.5645 28.6405 30.3008 29.1581L23.6504 41.9999C22.957 43.3378 21.043 43.3378 20.3496 41.9999L13.6992 29.1581C13.4355 28.6405 13.1426 28.1327 12.8398 27.6346C12.4883 27.0487 12.1855 26.4237 11.9512 25.7792C11.541 24.6366 11.3164 23.4159 11.3164 22.1366C11.3164 16.2089 16.1504 11.4042 22.0977 11.453C27.957 11.4921 32.7129 16.3261 32.6836 22.1854Z",
    fill: "white",
    stroke: "#185888",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.9277C24.8046 27.9277 27.0781 25.6542 27.0781 22.8496C27.0781 20.045 24.8046 17.7715 22 17.7715C19.1954 17.7715 16.9219 20.045 16.9219 22.8496C16.9219 25.6542 19.1954 27.9277 22 27.9277Z",
    fill: "#FF9500",
    stroke: "#185888",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7266 14.2168C27.5664 14.5781 28.2988 15.1543 28.8555 15.877",
    stroke: "#185888",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7051 31.2383L20.3496 31.7266",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7051 30.623L20.9844 31.6094",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6328 30.7109L20.9844 30.9844",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5762 32.7911C17.5762 33.4064 17.459 34.0021 17.2637 34.5489C17.1465 34.8712 17 35.1739 16.8242 35.4572C16.6777 35.7013 16.5312 35.9454 16.4043 36.1993L13.1426 42.4982C12.8008 43.1525 11.8633 43.1525 11.5215 42.4982L8.25977 36.1993C8.13281 35.9454 7.98633 35.7013 7.83984 35.4572C7.66406 35.1739 7.51758 34.8614 7.40039 34.5489C7.19531 33.9923 7.08789 33.3868 7.08789 32.7618C7.08789 29.8517 9.46094 27.4982 12.3809 27.5177C15.252 27.547 17.5859 29.9103 17.5762 32.7911Z",
    fill: "white",
    stroke: "#185888",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.332 35.6035C13.7073 35.6035 14.8223 34.4886 14.8223 33.1133C14.8223 31.738 13.7073 30.623 12.332 30.623C10.9567 30.623 9.8418 31.738 9.8418 33.1133C9.8418 34.4886 10.9567 35.6035 12.332 35.6035Z",
    fill: "#FF9500",
    stroke: "#185888",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2949 29.1777C14.7148 29.3633 15.0859 29.6465 15.3594 30.0078",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 37.8105L11.8926 38.2012",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 37.3223L12.4004 38.1035",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1172 37.3906L12.4004 37.6055",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6797 29.1483C38.6797 29.9881 38.5234 30.7889 38.25 31.5409C38.0938 31.9706 37.8984 32.3905 37.6543 32.7811C37.4492 33.1131 37.2637 33.4452 37.0781 33.7967L32.6543 42.3514C32.1953 43.2401 30.916 43.2401 30.457 42.3514L26.0332 33.7967C25.8574 33.4549 25.6621 33.1131 25.457 32.7811C25.2227 32.3905 25.0273 31.9803 24.8613 31.5409C24.5879 30.7792 24.4316 29.9686 24.4316 29.1092C24.4316 25.1639 27.6445 21.9608 31.6094 21.9999C35.5352 22.0292 38.6992 25.2421 38.6797 29.1483Z",
    fill: "white",
    stroke: "#185888",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5703 32.9668C33.4364 32.9668 34.9492 31.454 34.9492 29.5879C34.9492 27.7218 33.4364 26.209 31.5703 26.209C29.7042 26.209 28.1914 27.7218 28.1914 29.5879C28.1914 31.454 29.7042 32.9668 31.5703 32.9668Z",
    fill: "#FF9500",
    stroke: "#185888",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3438 23.8359C34.959 24.1484 35.4961 24.5684 35.9453 25.0762",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7207 36.5312L31.3652 37.0195",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7207 35.916L32 36.8926",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6484 35.9941L32 36.2676",
    stroke: "#185888",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0469 43.0059H43.0547",
    stroke: "#185888",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.918 43.0059H38.6797",
    stroke: "#185888",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40625 43.0059H25.8867",
    stroke: "#185888",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17969 43.0059H7.08789",
    stroke: "#185888",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93555 27.0002L5.39844 26.258L4.60742 25.8576C4.58789 25.8478 4.58789 25.8185 4.60742 25.8088L6.07227 25.2619C6.0918 25.2521 6.11133 25.2716 6.10156 25.2912L5.97461 26.9806C5.97461 27.0099 5.94531 27.0197 5.93555 27.0002Z",
    fill: "#185888"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42578 23.7091L7.88867 22.967L7.09766 22.5666C7.07813 22.5568 7.07813 22.5275 7.09766 22.5177L8.5625 21.9709C8.58203 21.9611 8.60156 21.9806 8.5918 22.0002L8.46484 23.6896C8.46484 23.7189 8.43555 23.7287 8.42578 23.7091Z",
    fill: "#185888"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5352 9.77344L29.7344 10.0566",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5781 8.65039L28.9727 9.39258",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0938 8.85547L28.1816 7.95703",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.a69b8642fd1b0734030a48296146e7fe.svg";
export { ForwardRef as ReactComponent };